var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34.6667,
    height: 34.6667,
    rx: 17.3333,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8568 22.8946C21.9309 21.5966 21.9996 19.7428 21.9996 17.3333C21.9996 15.2075 21.9461 13.681 21.8833 12.6222C21.8431 11.9439 21.3714 11.4728 20.7068 11.4301C19.8687 11.3762 18.7548 11.3333 17.333 11.3333C15.9112 11.3333 14.7973 11.3762 13.9592 11.4301C13.2946 11.4728 12.8228 11.944 12.7826 12.6223C12.7199 13.6811 12.6664 15.2075 12.6663 17.3333C12.6663 19.7428 12.7351 21.5966 12.8091 22.8946L16.1796 20.5154C16.8711 20.0273 17.7949 20.0273 18.4863 20.5154L21.8568 22.8946ZM13.8738 10.0995C12.5308 10.1857 11.5313 11.2001 11.4516 12.5434C11.3871 13.6325 11.333 15.1856 11.333 17.3333C11.333 20.6837 11.4645 22.9818 11.5623 24.2274C11.6017 24.7293 12.1632 24.9826 12.5744 24.6923L16.9485 21.6047C17.179 21.442 17.4869 21.442 17.7174 21.6047L22.0915 24.6923C22.5028 24.9826 23.0642 24.7293 23.1036 24.2274C23.2014 22.9818 23.333 20.6837 23.333 17.3333C23.333 15.1856 23.2789 13.6324 23.2143 12.5433C23.1347 11.2 22.1352 10.1857 20.7923 10.0995C19.9241 10.0437 18.7815 10 17.333 10C15.8845 10 14.742 10.0437 13.8738 10.0995Z",
    fill: "#240501"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.8b0b79c1cc33adaccac0e985eb390cca.svg";
export { ForwardRef as ReactComponent };